import { getAPIPath } from '@interhyp/platform-request';
import fetchWrapper, { getConnection } from '@interhyp/util-request';

import { Appointment, NewAppointment } from '../interfaces/Appointment';

export const getAppointments = async (intentId: string | undefined): Promise<Appointment[]> => {
  try {
    const res = await fetchWrapper(
      getConnection(),
      `${getAPIPath(
        'advisory-excellence-portal',
      )}/home/api/customers/intent/v1/intents/${intentId}/appointments`,
    );
    // check response
    if (res.status === 200) {
      return res.json();
    }
    return [];
  } catch {
    return [];
  }
};

export const getNewAppointments = async (caseId: string): Promise<NewAppointment[]> => {
  try {
    const res = await fetchWrapper(
      getConnection('website'),
      `${getAPIPath('customer-generation-bff')}/appointments?appId=${caseId}&status=NEW`,
      { method: 'GET' },
    );
    // check response
    if (res.status === 200) {
      return res.json();
    }
    return [];
  } catch {
    return [];
  }
};
